import Vue from 'vue';
import VeeValidate from 'vee-validate';
import nl from 'vee-validate/dist/locale/nl';
import axios from 'axios';
import VueRecaptcha from 'vue-recaptcha';

Vue.use(VeeValidate);

Vue.component('pressrelease-signup', {
    components: {
        'vue-recaptcha': VueRecaptcha
    },
    data: function() {
        return {
            form: {
                firstName: '',
                lastName: '',
                company: '',
                email: ''
            },
            success: false,
            errorMessage: ''
        };
    },
    mounted() {
        this.$validator.localize('nl', nl);
    },
    methods: {
        formSubmit(e) {
            e.preventDefault;

            this.$validator.validateAll().then(result => {
                if (result) {
                    this.active = true;
                    this.$refs.recaptcha.execute();
                }
            });
        },
        postForm(recaptchaToken) {
            this.$refs.recaptcha.reset();

            const antiforgeryToken = document.querySelector(
                "input[name='__RequestVerificationToken']"
            ).value;

            const formData = new FormData();
            formData.append('RequestVerificationToken', antiforgeryToken);
            formData.append('firstName', this.form.firstName);
            formData.append('lastName', this.form.lastName);
            formData.append('company', this.form.company);
            formData.append('email', this.form.email);
            formData.append('recaptchaToken', recaptchaToken);

            axios
                .post('/umbraco/surface/PressReleasePost/Subscribe', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                })
                .then(response => {
                    if (response.data.Success == true) {
                        this.success = true;
                    } else {
                        this.success = false;
                        this.errorMessage = response.data.ErrorMsg;
                    }
                })
                .catch(function() {
                    this.success = false;
                });
        }
    }
});
